import api from './api';

const BASE = '/natcash-fees';

export default {
  list: (kind) =>
    api.get(BASE, { params: { functionCode: 'NATCASH_FEE_VIEW', kind } }).then(r => r.data),

  save: (kind, rules) =>
    api.put(
      BASE,
      { rules, functionCode: 'NATCASH_FEE_UPDATE' },
      { params: { kind } }
    ).then(r => r.data),
};